import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import { logout } from '../../services/authURLs';
import { currentUser } from '../../services/userURLs';

import Modal from './Modal';
import RenderDropdown from './RenderDropdown';
import RenderLogin from './RenderLogin';
import './Navbar.css';

class ProductionNavigation  extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal:false,
      photo: '',
      name: ''
    }
  }
 


  toggle = () => {
    this.setState({modal: !this.state.modal})
  }

  componentDidMount = () => {
    console.log(this.props, "props prod nav\n", this.state, "state prod nav\n")

    axios.get(currentUser, { withCredentials: true })
      .then(response => {
        console.log(response.data, "response.data\n")
        const { name, photo } = response.data[0];
        this.setState({ name, photo})
      })
      .catch(err => {
        console.log({Error: err.message})
      })
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <a className="navbar-brand" href="/">
          CineView
        </a>
        <Button
          className="navbar-toggler bg-light"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </Button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <form onSubmit={() => this.props.searchHandler(this.props.inputCriteria)}>
            <input
              className="form-control"
              placeholder="Search"
              type="text"
              name="inputCriteria"
              value={this.props.inputCriteria}
              onChange={this.props.handleChange}
              id="nav-input"
            />
            <div onClick={() => this.props.searchHandler(this.props.inputCriteria)}>
              <Link 
                id="nav-button"
                to={`/search/?q=${this.props.inputCriteria}`}>
                <button
                  className="btn btn-outline-success"
                >
                  <FontAwesomeIcon icon={faSearch} />
                </button>
              </Link>
            </div>

          </form>
          <ul className="navbar-nav">
            <li className="nav-item active">
              <Link className="nav-link" to="/premium">
                Premium Subscriptions
              </Link>
            </li>
            <li className="nav-item active">
              <RenderLogin>
                <Modal
                  buttonLabel="Log In"
                  modal={this.state.modal}
                  toggle={this.toggle}
                  className="modal-open"
                />
              </RenderLogin>
            </li>
            <RenderDropdown>
              <a className="logout" href={logout}>
                <div className="bg-light logout">Logout</div>
              </a>
              <Link to="/myreviews" className="avatar-link">
                <img className="avatar" src={this.state.photo} alt="avatar" />
                <div className="welcome logout"><h6 className="logout">Welcome,{` ${this.state.name}`}!</h6></div>
              </Link>
            </RenderDropdown>
          </ul>
        </div>
      </nav>
    );
  }

  
  }


export default ProductionNavigation;
